export type TriageFlowStatus =
  | "notStarted"
  | "completed"
  | "inProgress"
  | "terminate"
  | "none";

/** View-model row for the Triage Results grid. */
export type TriageResultRow = {
  /** Unique result identifier (e.g. TRI_004821). Used as DataGrid row id. */
  resultId: string;
  objectType: string;
  objectTypeName: string;
  objectSubType: string;
  objectSubTypeName: string;
  objectId: string;
  title: string;
  version: string;
  /** Empty string renders as "-". */
  triageResult: string;
  /** When true, triage result is styled as a link. */
  triageResultIsLink: boolean;
  flowStatus: TriageFlowStatus;
  /** ISO date string for filtering and display formatting. */
  createDate: string;
};

export const TRIAGE_FLOW_STATUS_LABELS: Record<TriageFlowStatus, string> = {
  notStarted: "Not Started",
  completed: "Completed",
  inProgress: "In Progress",
  terminate: "Terminate",
  none: "-",
};
